import type { IconData } from '@stacksjs/iconify-core'

export const clearAll: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M160 112h336v32H160zM88 240h336v32H88zM16 368h336v32H16z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default clearAll
